//API
export const MAINTENANCE_PLAN_ACCOUNT = (orgnr: string) => `account/${orgnr}`;
export const MAINTENANCE_PLAN_READ_ACTIVITY = (activityId?: string) => `read-activity?ActivityId=${activityId}`;
export const MAINTENANCE_PLAN_READ_ACTIVTIES = (communityId: string) => `read-maintenanceplan?CommunityId=${communityId}`;
export const MAINTENANCE_PLAN_GET_ANSWERS = (id: string) => `community/${id}/questionnaire`;
export const MAINTENANCE_PLAN_CREATE = (id: string) => `community/${id}/maintenance-plan`;
export const MAINTENANCE_PLAN_QUESTIONNAIRE = "questionnaire";
export const MAINTENANCE_PLAN_UPDATE = "update-activity";

export const BOOKING_APPOINTMENTS = (fromDate: string, untillDate: string) => `booking/appointments?from=${fromDate}&until=${untillDate}`;
export const BOOKING_READ_APPOINTMENTS = (userId?: string) => `booking/users/${userId}/appointments`;
export const BOOKING_DELETE_APPOINTMENTS = (userId?: string, id?: string) => `booking/users/${userId}/appointments/${id}/delete`;
export const BOOKING_CATEGORIES = "booking/appointment-categories";

export const SUBSCRIPTION_GET_BRFS = (contactId: string | unknown) => `users/${contactId}/login`;
export const SUBSCRIPTION_ADD = `add-subscription`;

export const INSERT_COMMUNITY = `account`;
